import React, {memo} from "react"
import style from "styles/mysterySlider.module.css"
import useLocale from '../../../../hooks/useLocale'
import NftSlider from '../../../content/components/NFT/nftSlider'
import {useRouter} from 'next/router'

const Slider = () => {
	const router = useRouter()
	const {mysterySlider} = useLocale()

	return (
		<div className={style.mysterySlider}>
			<div
				data-aos-once="true"
				data-aos="fade-left"
				data-aos-offset="100"
				data-aos-easing="ease-in-sine"
				className={style.container}>
				<div className={style.title}>{mysterySlider.title}</div>
				<div className={style.subtitle}>{mysterySlider.subtitle}</div>
			</div>

			<div
				data-aos-once="true"
				data-aos="fade-left"
				data-aos-offset="100"
				data-aos-easing="ease-in-sine"
				className="lg:mb-[100px] mb-[60px]">
				<NftSlider/>
			</div>

			<div className={style.container}>
				<div
					data-aos-once="true"
					data-aos="fade-left"
					data-aos-offset="100"
					data-aos-easing="ease-in-sine"
					className={style.more}>
					<img onClick={() => window.open("https://designrr.page/?id=130306&token=1785682334&h=2842", "_blank")} alt="" src="/image/mystery/book.webp"/>

					<div>
						<p className={style.bookTitle}>{mysterySlider.secondTitle}</p>
						<button onClick={() => {
							router.push('/book')
						}} className={style.button}>{mysterySlider.button}</button>
					</div>
				</div>

				<div
					data-aos-once="true"
					data-aos="fade-left"
					data-aos-offset="100"
					data-aos-easing="ease-in-sine"
					className={style.wolfPass}>
					<div>
						<p className={style.wolfTitle}>{mysterySlider.wolfTitle}</p>
						<p className={style.wolfText}>{mysterySlider.wolfText}</p>
						<button
							className={style.button}
							onClick={() => window.open('https://nft.metaisland.gg', '_blank')}>{mysterySlider.secondButton}
						</button>
					</div>

					<div className={style.nftCard}>
						<img alt="" src="/image/mystery/nft7.webp"/>

						<div className={style.nftText}>
							<p>{mysterySlider.nftTitle}</p>
							<p className="opacity-60">{mysterySlider.nftText}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default memo(Slider)
